import { z } from 'zod'

import { DateZod } from '../common'

export const MilestoneTypeZod = z.enum([
  'registered',
  'eveningEnded',
  'newPresence',
  'volunteerAnniversary',
  'birthday',
])

export const MilestoneZod = z.object({
  type: MilestoneTypeZod,
  imageUrl: z.string().optional(),
  createdAt: DateZod,
  eveningDate: DateZod.optional(),
  clients: z.number().optional(),
  km: z.number().optional(),
  donations: z.number().optional(),
  presenceCount: z.number().optional(),
  yearsOfParticipation: z.number().optional(),
  skipNotification: z.boolean().optional(),
})

export type Milestone = z.infer<typeof MilestoneZod>
